module.exports = __webpack_public_path__ + "assets/media/drills.6449a080.mp4";